<template>
    <form @submit.prevent="handleSubmit">  
        <label>Name</label>
        <input type="name" placeholder="name here" required v-model="name">
        <div class="error" v-if="invalidName">{{ invalidName }}</div>
        <label>Email</label>
        <input type="email" placeholder="email here" required v-model="email" @change="validateEmail">

        <label>Country</label>
        <select v-model="country">
            <option value="nl">Nederland</option>
            <option value="us">United States</option>
        </select>

        <label>Skills</label>
        <input type="text" placeholder="add skill + Enter" v-model="tempSkill" @keyup="addSkill">
        <div v-for="skill in skills" :key="skill">
            <span @click="deleteSkill(skill)">{{ skill }}</span>
        </div>

        <div class="terms">
            <input type="checkbox" v-model="terms" required>
            <label>Accept terms & conditions</label>
        </div>

        <div class="submit">
            <button>Create account</button>
        </div>


    </form>

    <p>name: {{ name }}</p>
    <p>email: {{ email }}</p>
    <p>country: {{ country }}</p>
    <p>terms: {{ terms }}</p>
    <p>skills: {{ skills }}</p>

</template>

<script>
export default {
    data() {
       return {
           name: '',
           email: '',
           country: 'nl',
           terms: false,
           invalidName: '',
           invalidEmail: '',
           tempSkill: '',
           skills: []
       } 
    },
    methods: {
        addSkill(e) {
            console.log(" pressed: " + e.key);
            if(e.key === "Enter" && this.tempSkill) {

                console.log("comma pressed");
                if(!this.skills.includes(this.tempSkill)) {

                    this.skills.push(this.tempSkill)
                }
                this.tempSkill = '';
          
            }
        },
        deleteSkill(skill) {
            this.skills = this.skills.filter((item) => {
                return skill !== item
            })
        },
        validateEmail() {
            console.log("validateEmail:" + this.email);
        },
        handleSubmit() {
            console.log("handleSubmit fired");
            // validate name
            this.invalidName = this.name.length > 5 ? 
                '' : 'Name must be at least 6 characters long'
            console.log("this.invalidName: " + this.invalidName);

        }
    }
}
</script>

<style>

</style>